export const ORIGIN_BASE_URL =
  process.env.REACT_APP_ORIGIN_BASE_URL || "https://gadder.ai";
